import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';
import CheckCircleIcon from '@ps-design-system/icons/CheckCircle/CheckCircle20';

import { usePauseModal } from '../context/PauseModalContext';

const BlockTime = () => {
  const { spaceID } = usePauseModal();

  const handleClick = () => {
    window.location.href = `/calendar/${spaceID}`;
  };

  return (
    <div className="pause-listing-container pause-blocked-times">
      <Text typeface="headline-2-m">
        <FormattedMessage id="pause.modal_blocked_times.title" defaultMessage="Block time"/>
      </Text>
      <Text typeface="body-2">
        <FormattedMessage id="pause.modal_blocked_times.description" defaultMessage="Recommended for short term blocking on specific dates."/>
      </Text>
      <div className="reasons-container">
        <div className="reason-container">
          <div className="icon"><CheckCircleIcon /></div>
          <div>
            <Text typeface="body-1">
              <FormattedMessage id="pause.modal_blocked_times.search" defaultMessage="Appears in search"/>
            </Text>
          </div>
        </div>
        <div className="reason-container">
          <div className="icon"><CheckCircleIcon /></div>
          <div>
            <Text typeface="body-1">
              <FormattedMessage id="pause.modal_blocked_times.inquiries" defaultMessage="Allows booking requests and inquiries"/>
            </Text>
          </div>
        </div>
        <div className="reason-container">
          <div className="icon"><CheckCircleIcon /></div>
          <div>
            <Text typeface="body-1">
              <FormattedMessage id="pause.modal_blocked_times.live" defaultMessage="Listing remains live"/>
            </Text>
          </div>
        </div>
      </div>
      <Button fullWidth onClick={handleClick}>
        <FormattedMessage id="pause.modal_blocked_times.button" defaultMessage="Continue to calendar"/>
      </Button>
    </div>
  );
};

export default BlockTime;
